import { takeEvery, put, all } from 'redux-saga/effects';

import apiFetcher from '../../tools/api-fetcher';
import queryStringify from '../../tools/query-stringify';
import handleError from '../../tools/error-helper';

import * as types from '../../actions/admin/schools/types';
import * as actions from '../../actions/admin/schools';

function* getAdminSchools({ queryParams }) {
  yield put(actions.setAdminSchoolsLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`admins/schools?${queryStringify({ ...queryParams })}`);

    yield put(actions.setAdminSchools(data));
  } catch (exception) {
    handleError(exception, 'Failed to load schools.');
  }

  yield put(actions.setAdminSchoolsLoading(false,));
}

export default function* adminSchoolsSaga() {
  yield all([
    takeEvery(types.ADMIN_SCHOOLS_GET_LIST, getAdminSchools)
  ]);
}


// WEBPACK FOOTER //
// ./src/sagas/admin/admin-schools.js